import { useEffect } from 'react';

import observer from 'saddlebag-observer';

type Props = {
  distilledExperiment: { variant: string; name: string };
  pageType: string;
};

/**
 * Hook to track distilled experiment variants via Google Analytics
 * Publishes a tracking event when a user is part of a distilled experiment
 * @returns {void}
 */
export const useDistilledExperimentTracking = ({
  distilledExperiment,
  pageType,
}: Props) => {
  useEffect(() => {
    const { name, variant } = distilledExperiment;
    if (name && variant) {
      observer.publish('tracking-event', {
        ga: [
          {
            category: `${pageType}-results-distilled-experiment`,
            action: variant,
            label: `${name} Results Variant ${variant.toUpperCase()}`,
          },
        ],
      });
    }
    // Only track on component mount, not on prop changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
